// Purpose: Google Analytics tracking code.

import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-HMRJCJPB46");
};

export const logPageView = () => {
    ReactGA.send("pageview");
};